export const findFirstFocusableElement = (): HTMLElement | null => {
  const container = document.querySelector<HTMLElement>('main');
  if (!container) return null;

  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ];

  const focusableElements = Array.from(
    container.querySelectorAll<HTMLElement>(focusableSelectors.join(','))
  );

  focusableElements.sort((a, b) => {
    // eslint-disable-next-line no-bitwise -- compareDocumentPosition returns a bitmask; this is the standard way to read it
    return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  });
  return focusableElements[0] || null;
};
